import { Text } from './Text';
import { TextHeading } from './TextHeading/TextHeading';
import { TextEllipse } from './TextEllipse/TextEllipse';
Text.Heading = TextHeading;
Text.Ellipse = TextEllipse;
export { Text };